// --------------------------------------------------------------------------
// MODULE #90 – HOMES ACTIVITY MAP
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

/* global dataLayer */

'use strict';

var $ = require('jquery');
var GoogleMapsLoader = require('google-maps');
GoogleMapsLoader.KEY = 'AIzaSyAp8yQAy-Y3pI6dPwDWFaMjxS47CgroM2w';
GoogleMapsLoader.LIBRARIES = ['places'];
var postal = require('postal');
var channel = postal.channel();
var mapResize = require('../map-resize');
var MarkerClusterer;

module.exports = function (options) {
  // context of where the module has been called from
  var context = options.context;

  // map canvas
  var mapCanvas = context[0];

  /* current location and postode entry form */
  var activityForm = $('[data-binding="activity-form"]');
  var addressInputField = activityForm.find('[data-binding="address-lookup-field"]');
  var currentLocationButton = activityForm.find('[data-binding="current-location-button"]');
  var currentLocationPostcodeContainer = activityForm.find('[data-binding="current-location-postcode-wrapper"]');

  // infobox list that slides in
  var infoBoxListWrapper = $('[data-binding="info-box-list-wrapper"]');
  var infoBoxList = $('[data-binding="info-box-list"]');
  var closeInfoBoxList = $('[data-binding="close-info-box-list"]');

  // load more button
  var loadMoreButton = '<a href="@Model.LoadMoreUrl" class="button" data-binding="activities-map-listing-load-more" data-ga="load-more-activities">' + '<span class="button__text">Load more</span>' + '<!--[if gte IE 9]><!-->' + '<svg width="27px" height="23px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 26 27" enable-background="new 0 0 26 27" xml:space="preserve">' + '<rect y="13" fill="#ffffff" width="25.3" height="1"></rect>' + '<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#ffffff" points="12.7,0 24.8,13.5 12.7,27 13.9,27 26,13.5 26,13.5 13.9,0"></polygon>' + '</svg>' + '<!--<![endif]-->' + '<!--[if lte IE 8]>' + '<img src="/Static/images/icons/arrow-right-white.png" alt="Right arrow" />' + '<![endif]-->' + '</a>';

  // global for storing the googleObj once it has been created
  var googleObj;

  // the actual google map
  var map;

  // will contain the markercluster module wide variable
  var mc;

  // geocoder for turn geolocation into a street address
  var geocoder;

  // array for all the markers to go in
  var markers = [];

  // array for all the info boxes to go into
  var infoboxes = [];

  // variables for the set up of the map
  var theLodge, inlineLatLng, initialCenter;

  // global variables for the module to contain the autocomplete object and the places service
  var autocompleteOptions;
  var autocomplete;

  // Google place lookup
  var place;

  // activity pin urls
  var singleActivityPinUrl = '/Static/images/icons/single-map-pin.png';
  var multipleActivityPinUrl = '/Static/images/icons/multi-map-pin.png';
  var clusterActivityPinUrl = '/Static/images/icons/cluster-map-pin.png';

  var currentPage = 1;

  var activeTab = 'map';

  /**
  * Function for grabbing all the results from a search
  * @param  {[type]} config - an object with config options including lat, long and radius
  * @return {jQuery AJAX promise} a promise containing a jquery AJAX object
  */
  function getResults(config) {
    var data = {
      Latitude: config.lat,
      Longitude: config.lng,
      Radius: config.rds,
      TopLeft: config.nw,
      TopRight: config.ne,
      BottomRight: config.se,
      BottomLeft: config.sw
    };

    return $.ajax({
      cache: false,
      data: data,
      method: 'GET',
      url: window.location.href
    });
  }

  /**
  *
  * Handles any errors with whilst grabbing the browser geolocation
  * @param  {Error} error - the error passed by the call to the browsers geolcation funcition
  */
  function handleGeolocationError(error) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        alert('Currently you are not allowing us to use your location data, please amend this in your browser\'s settings if you wish to use this feature');
        break;
      case error.POSITION_UNAVAILABLE:
        alert('Location information is currently unavailable.');
        break;
      case error.TIMEOUT:
        alert('The request to get user location timed out.');
        break;
      case error.UNKNOWN_ERROR:
        alert('An unknown error occurred.');
        break;
    }
  }

  /**
  * [getCurrentLocation description]
  * @param  {Function} callback [description]
  * @return {[type]}            [description]
  */
  function getCurrentLocation(callback) {
    callback = typeof callback === 'function' ? callback : null;
    $(currentLocationButton).prop('disabled', true).css('opacity', 0.25);
    return navigator.geolocation.getCurrentPosition(callback, handleGeolocationError);
  }

  /**
  * Center the map
  * @param  {Object} config - the latlng to center the map at
  */
  function centerMap(config) {
    map.setCenter(config.latLng);
  }

  /**
  * Make the map zoom to fit the bounds passed into this function
  * @param  {Object} config - object containing the bounds for the map
  */
  function fitBounds(config) {
    map.fitBounds(config.bounds);
    if (map.getZoom() > 15) {
      map.setZoom(15);
    }
  }

  /**
  * A function to calculate the raidus from the current center of the map
  * @return {Number} dis - the distance in miles
  */
  function getMapRadius() {
    // http://stackoverflow.com/questions/3525670/radius-of-viewable-region-in-google-maps-v3
    var bounds = map.getBounds();

    var center = bounds.getCenter();
    var ne = bounds.getNorthEast();

    if (center.lat() === ne.lat() && center.lng() === ne.lng()) {
      if (place !== undefined) {
        center = place.geometry.location;
        ne = place.geometry.viewport.getNorthEast();
      }
    }

    // r = radius of the earth in statute km
    var r = 6371.0;

    // Convert lat or lng from decimal degrees into radians (divide by 57.2958)
    var lat1 = center.lat() / 57.2958;
    var lon1 = center.lng() / 57.2958;
    var lat2 = ne.lat() / 57.2958;
    var lon2 = ne.lng() / 57.2958;

    // distance = circle radius from center to Northeast corner of bounds
    var dis = r * Math.acos(Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1));

    // set map radius, with minimum of 1 km radius
    if (dis < 1) {
      return 1;
    }

    return dis;
  }

  /**
  * Update the address lookup field with an address if a user uses the built in browser location
  * @param  {Google.LatLng} latLng - the latLng to geocode
  */
  function geocodeAddressField(latLng) {
    geocoder.geocode({
      'latLng': latLng
    }, function (results, status) {
      if (status === googleObj.maps.GeocoderStatus.OK) {
        if (results[1]) {
          addressInputField.value = results[1].formatted_address; // jshint ignore:line
          $(activityForm).trigger('submit');
        } else {
          addressInputField.value = 'No results found';
        }
      } else {
        alert('Geocoder failed due to: ' + status);
      }
    });
  }

  /**
  * Generates the html for an infobox
  * @param  {Object} data - the data for the map pin
  * @return {string} html - string representing the html for the infobox
  */
  function createInfoBox(data) {
    var html = '<li class="activities-map-listing__activity">' + '<img src="' + data.Img + '" alt="' + data.Title + '" class="image" />' + '<div class="text">' + '<h3 class="name">' + data.Title + '</h3>' + '<p class="completed-by">' + data.Type + ' ' + data.Date + '</p>' + '<a class="link" href="' + data.Url + '" data-ga="activity-map">Do this activity</a>' + '</div>' + '</li>';
    return html;
  }

  /**
  * Bind a click event to the map pins to fire a custom info window
  * @param  {googleObj.maps.Marker} marker - the marker to bind th click handler to
  * @param  {google.maps.Map} map -
  * @param  {String} html -
  */
  function bindInfoWindow(marker, map, html) {
    googleObj.maps.event.addListener(marker, 'click', function () {
      $(closeInfoBoxList).addClass('active');
      $(infoBoxListWrapper).addClass('active');
      $(infoBoxList).empty().append(html);
      dataLayer.push({
        'category': 'activityMap'
      });
    });
  }

  /**
  * Build the map marker
  * @param  {Object} data - all the data for the map pin
  */
  function createMapMarker(data) {
    var latLng = new googleObj.maps.LatLng(data.Latitude, data.Longitude);
    var html = createInfoBox(data);
    var newHtml = html;

    var marker = new googleObj.maps.Marker({
      icon: singleActivityPinUrl,
      position: latLng,
      map: map
    });

    for (var i = 0; i < markers.length; i++) {
      var currentMarker = markers[i];
      var currentInfoBox = infoboxes[i];
      var position = currentMarker.getPosition();

      if (latLng.equals(position)) {
        marker.setIcon(multipleActivityPinUrl);
        currentMarker.setIcon(multipleActivityPinUrl);
        newHtml = currentInfoBox + html;
        infoboxes[i] = newHtml;
      }
    }

    infoboxes.push(newHtml);
    markers.push(marker);

    bindInfoWindow(marker, map, newHtml);
  }

  /**
  * Update the marker clusterer by reinitialising it
  */
  function updateMarkerClusterer() {
    var clusterStyles = [
    //small
    {
      backgroundPosition: '0px 9px',
      height: 68,
      textColor: '#fff',
      textSize: 14,
      url: clusterActivityPinUrl,
      width: 48
    },
    //medium
    {
      backgroundPosition: '0px 9px',
      height: 68,
      textColor: '#fff',
      textSize: 14,
      url: clusterActivityPinUrl,
      width: 48
    },
    //large
    {
      backgroundPosition: '0px 9px',
      height: 68,
      textColor: '#fff',
      textSize: 14,
      url: clusterActivityPinUrl,
      width: 48
    }];

    var mcOptions = {
      maxZoom: 15,
      styles: clusterStyles
    };

    mc = new MarkerClusterer(map, markers, mcOptions);
  }

  /**
  * Redraws pins on the map
  * @param  {Array} pins - an array of pin locations
  */
  function updateMapPins(pins) {
    markers = [];
    infoboxes = [];
    for (var i = 0; i < pins.length; i++) {
      var pin = pins[i];
      createMapMarker(pin);
    }
    updateMarkerClusterer();
  }

  /**
  * Updates the load more button's url
  * @param  {string} url - new url
  */
  function updateLoadMoreUrl(url) {
    $('[data-binding="activities-map-listing-load-more"]').attr('href', url);
  }

  /**
  * Update the list view of the activities map section
  * @param  {String} html the activities list to returned from the AJAX call
  */
  function updateListView(options) {
    var html = options.html;
    var url = options.url;

    var listView = $('#list-view');
    var activityList = $(html).filter('ul.activities-map-listing__activity-list');
    var activityItems = activityList.find('.activities-map-listing__activity');

    if (url !== '') {
      $('.section-wrapper--load-more').empty();
      $('.section-wrapper--load-more').append(loadMoreButton);
      updateLoadMoreUrl(url);

      if (listView.hasClass('active')) {
        $('[data-binding="activities-map-listing-load-more"]').show();
      } else {
        $('[data-binding="activities-map-listing-load-more"]').hide();
      }
    } else {
      $('[data-binding="activities-map-listing-load-more"]').remove();
    }

    if (url.length) {
      currentPage = url.split('&Page=')[1] - 1;
    }

    if (options.newSearch) {
      $('[data-binding="list-view-activity-list"]').empty();
    }

    var ul = $('ul.activities-map-listing__activity-list');
    var div = $('div.activities-map-listing__activity-list');

    if (activityItems.length) {
      if (ul.length) {
        ul.append(activityItems);
      } else {
        div.remove();
        listView.prepend(activityList);
      }
      if (activityItems.length > 4) {
        var top = listView.find('.activities-map-listing__activity').eq(4 * currentPage).position().top;
        $('[data-binding="list-view-activity-list"]').animate({
          scrollTop: top
        }, 1000);
      }
    } else {
      ul.remove();
      div.remove();
      listView.prepend('<div class="activities-map-listing__activity-list">' + '<p>No activites found</p>' + '</div>');
    }
  }

  /**
  * Updates the "X people" part of the activites summary
  */
  function updateNumberOfPeople(count) {
    var countText, countText2;
    $('[data-binding="number-of-people"]').text(count);
    if (count === 1) {
      countText = 'person';
      countText2 = 'is';
    } else {
      countText = 'people';
      countText2 = 'are';
    }
    $('[data-binding="pluralisation-people"]').text(countText);
    $('[data-binding="pluralisation-people-2"]').text(countText2);
  }

  /**
  * Calls the getResults function, waits for the callback and updates the map and list views
  * @param  {Object} config - grabs the lat, lng and raidus to search with
  */
  function updateResults(config) {
    getResults(config).done(function (data) {
      updateMapPins(data.data.activities);
      updateListView({
        html: data.html,
        newSearch: true,
        url: data.data.url
      });
      updateNumberOfPeople(data.data.activities.length);
    });
  }

  /**
  * Promise wrapped jquery AJAX function
  * @param  {string} url - url to GET
  */
  function loadMoreActivities(url) {
    return $.ajax({
      method: 'GET',
      url: url
    });
  }

  /**
  * Function called to update map after idle event
  */
  function updateMap() {
    var center = map.getCenter();
    var mapRadius = getMapRadius();
    var ne = map.getBounds().getNorthEast().lat() + ',' + map.getBounds().getNorthEast().lng();
    var sw = map.getBounds().getSouthWest().lat() + ',' + map.getBounds().getSouthWest().lng();
    var nw = map.getBounds().getSouthWest().lat() + ',' + map.getBounds().getNorthEast().lng();
    var se = map.getBounds().getNorthEast().lat() + ',' + map.getBounds().getSouthWest().lng();

    if (mapRadius > 2000 && $(window).width() <= 768) {
      mapRadius = 100;
    }

    if (activeTab === 'map') {
      updateResults({
        lat: center.lat(),
        lng: center.lng(),
        rds: mapRadius,
        ne: ne,
        sw: sw,
        nw: nw,
        se: se
      });
    }
  }

  /**
  * init function for the activities
  */
  function init() {

    GoogleMapsLoader.load(function (google) {
      googleObj = google;
      MarkerClusterer = require('../../plugins/marker-clusterer')(google);

      geocoder = new google.maps.Geocoder();

      // fallback location if no location is set in EpiServer, via the geolocation API in the browser or by typing in a postcode
      theLodge = new google.maps.LatLng(52.12195, -0.26177);

      // check to see if there is a data attribute set inline for the lat and lat and create variables for them
      var lat = parseFloat(context.data('map-lat'));
      var lng = parseFloat(context.data('map-lng'));

      // check that data has been grabbed otherwise set the initial lat lng to ''
      inlineLatLng = lat !== 'undefined' && lng !== 'undefined' ? new google.maps.LatLng(lat, lng) : '';

      // if inlineLatLng equals '' then set the center of the map to the lodge otherwise set initialCenter to the latlng provided in the data attr
      initialCenter = inlineLatLng === '' ? theLodge : inlineLatLng;

      var mapSettings = {
        center: initialCenter,
        zoom: 9,
        scrollwheel: false
      };

      // draw the map
      map = new google.maps.Map(mapCanvas, mapSettings);

      //Redraw map after resize
      mapResize(google, mapCanvas);
      //Listen for changes to the tabs
      channel.subscribe('tabChange', function (data) {
        //Check whether map tab is active
        //and only trigger resize and redraw if visible
        if (data.thisTabHref === '#map-view') {
          activeTab = 'map';
          $(window).trigger('resize');
        } else {
          activeTab = 'list';
        }
      });

      // set autocomplete options
      autocompleteOptions = {
        types: ['geocode'],
        componentRestrictions: {
          country: 'gb'
        }
      };

      /**
       * Called everytime a place lookup is required
       */
      function googlePlacesLookup() {

        place = autocomplete.getPlace();
        var lat, lng, googleLatLng, viewport;

        if (typeof place.address_components !== 'undefined') {
          lat = place.geometry.location.lat();
          lng = place.geometry.location.lng();
          googleLatLng = place.hasOwnProperty('geometry') ? place.geometry.location : '';
          viewport = place.hasOwnProperty('geometry') ? place.geometry.viewport : '';
        }

        if (typeof place.address_components !== 'undefined' && googleLatLng !== '' && viewport !== '') {
          centerMap({
            latLng: googleLatLng
          });

          fitBounds({
            bounds: viewport
          });
        }
      }

      autocomplete = new google.maps.places.Autocomplete(addressInputField[0], autocompleteOptions);

      google.maps.event.addListener(autocomplete, 'place_changed', googlePlacesLookup);

      google.maps.event.addListener(map, 'idle', updateMap);

      // wait until map has been drawn to show the postcode look up wrapper
      currentLocationPostcodeContainer.css('visibility', 'visible');

      // wait until google has loaded and the map has been drawn
      // to detect geolocation as geolocation is slightly meaningless
      // without the map
      if ('geolocation' in navigator) {
        currentLocationButton.parent().css('visibility', 'visible');

        $(currentLocationButton).on('click', function (e) {
          e.preventDefault();

          getCurrentLocation(function (pos) {
            var lat = pos.coords.latitude;
            var lng = pos.coords.longitude;
            var googleLatLng = new google.maps.LatLng(lat, lng);

            geocodeAddressField(googleLatLng);

            centerMap({
              latLng: googleLatLng
            });

            map.setZoom(12);
          });
        });
      }

      $(closeInfoBoxList).on('click', function (e) {
        e.preventDefault();
        $(this).removeClass('active');
        $(infoBoxListWrapper).removeClass('active');
        $(this).blur();
      });

      $(activityForm).on('submit', function (e) {
        e.preventDefault();
        google.maps.event.trigger(autocomplete, 'place_changed');
      });
    });

    $('.activities-map-listing').on('click', '[data-binding="activities-map-listing-load-more"]', function (e) {
      e.preventDefault();
      var url = window.location.href + $(this).attr('href');
      loadMoreActivities(url).done(function (data) {
        updateListView({
          html: data.html,
          newSearch: false,
          url: data.data.url
        });
      }).fail(function () {
        alert('Oops! Something went wrong, please try again.');
      });
    });
  }

  return {
    init: init
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/activities/activity-map.js
// module id = 200
// module chunks = 0